import React, { useState } from 'react'
import { Button } from '../ui/button'
import { Input } from '../ui/input'
import { Label } from '../ui/label'
import { Loader2 } from 'lucide-react'

export default function EventAnnouncementForm({ onSubmit, loading = false }) {
  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [isPublished, setIsPublished] = useState(true)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!title.trim() || !content.trim()) return
    await onSubmit({ title: title.trim(), content: content.trim(), isPublished })
    setTitle('')
    setContent('')
    setIsPublished(true)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Label htmlFor="announcement-title">Title</Label>
        <Input
          id="announcement-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Announcement title"
          maxLength={200}
          className="mt-1 bg-surface-linen border-surface-border text-charcoal"
        />
      </div>

      <div>
        <Label htmlFor="announcement-content">Content</Label>
        <textarea
          id="announcement-content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Write your announcement..."
          rows={4}
          className="mt-1 w-full rounded border border-surface-border bg-surface-linen px-3 py-2 text-sm text-charcoal placeholder:text-charcoal-muted focus:outline-none focus:ring-2 focus:ring-gold"
        />
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="announcement-published"
          checked={isPublished}
          onChange={(e) => setIsPublished(e.target.checked)}
          className="rounded border-surface-border text-gold focus:ring-gold"
        />
        <Label htmlFor="announcement-published" className="text-sm text-charcoal-muted cursor-pointer">
          Publish immediately
        </Label>
      </div>

      <Button
        type="submit"
        disabled={loading || !title.trim() || !content.trim()}
        className="bg-gold text-black hover:bg-gold/90"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin mr-2" />
            Posting...
          </>
        ) : (
          'Post Announcement'
        )}
      </Button>
    </form>
  )
}
